import {inject, Injectable} from '@angular/core';
import {HttpRequest, HttpHandler, HttpInterceptor} from '@angular/common/http';
import {ErrorService} from '../services/commons/error.service';
import {LoadingService} from "../services/commons/loading.service";
import {ProspectToLawFirmFormService} from "../services/entities/prospect-to-law-firm-form.service";
import {PaymentMethodFormService} from "../services/entities/payment-method-form.service";
import {NewContractFormService} from "../services/entities/new-contract-form.service";
import {OnBoardingFormService} from "../services/entities/on-boarding-form.service";
import {LawFirmUserOnBoardingFormService} from "../services/entities/law-firm-user-on-boarding-form.service";

@Injectable()
export class QueryInterceptor implements HttpInterceptor {
  private loadingService = inject(LoadingService)
  private prospectToLawFirmFormService = inject(ProspectToLawFirmFormService)
  private paymentMethodFormService = inject(PaymentMethodFormService)
  private newContractFormService = inject(NewContractFormService)
  private onBoardingFormService = inject(OnBoardingFormService)
  private lawFirmUserOnBoardingFormService = inject(LawFirmUserOnBoardingFormService)
  private errorService = inject(ErrorService)

  intercept(request: HttpRequest<any>, next: HttpHandler) {
    this.errorService.serverErrors.update(() => []);
    if (request.headers.has('x-current-loading')) {
      const currentLoading = this.loadingService.currentLoading();
      currentLoading.push(request.headers.get('x-current-loading') ?? '');
      this.loadingService.currentLoading.update(() => currentLoading);
    }
    if ((request.url.includes('/api/prospect_to_law_firm_forms') ||
        request.url.includes('create-setup-intent-from-prospect-to-law-firm-form')
      ) &&
      this.prospectToLawFirmFormService.bearer) {
      request = request.clone({
        setHeaders: {
          Authorization: `BearerF ${this.prospectToLawFirmFormService.bearer}`
        }
      });
    }
    if ((request.url.includes('/api/payment_method_forms') ||
      request.url.includes('create-setup-intent-from-payment-method-form')
    ) && this.paymentMethodFormService.bearer) {
      request = request.clone({
        setHeaders: {
          Authorization: `BearerF ${this.paymentMethodFormService.bearer}`
        }
      });
    }
    if ((request.url.includes('/api/new_contract_forms') ||
      request.url.includes('create-setup-intent-from-new-contract-form')
    ) && this.newContractFormService.bearer) {
      request = request.clone({
        setHeaders: {
          Authorization: `BearerF ${this.newContractFormService.bearer}`
        }
      });
    }
    if ((request.url.includes('/api/on_boarding_forms') || request.url.includes('/s3/upload-to-path') || request.url.includes('/s3/list-files') || request.url.includes('/s3/delete-file') || request.url.includes('/s3-crm/upload-to-path') || request.url.includes('/s3-crm/list-files') || request.url.includes('/s3-crm/delete-file'))
     && this.onBoardingFormService.bearer) {
      let url = request.url;
      if (this.onBoardingFormService.formId && (request.url.includes('/s3/') || request.url.includes('/s3-crm/'))) {
        const [path, query] = url.split('?');
        url = path + '/' + this.onBoardingFormService.formId + (query ? '?' + query : '');
      }
      request = request.clone({
        url,
        setHeaders: {
          Authorization: `BearerF ${this.onBoardingFormService.bearer}`
        }
      });
    }
    if ((request.url.includes('/api/law_firm_user_on_boarding_forms') || request.url.includes('/s3/upload-to-path') || request.url.includes('/s3/list-files') || request.url.includes('/s3/delete-file') || request.url.includes('/s3-crm/upload-to-path') || request.url.includes('/s3-crm/list-files') || request.url.includes('/s3-crm/delete-file'))
     && this.lawFirmUserOnBoardingFormService.bearer) {
      let url = request.url;
      if (this.lawFirmUserOnBoardingFormService.formId && (request.url.includes('/s3/') || request.url.includes('/s3-crm/'))) {
        const [path, query] = url.split('?');
        url = path + '/' + this.lawFirmUserOnBoardingFormService.formId + (query ? '?' + query : '');
      }
      request = request.clone({
        url,
        setHeaders: {
          Authorization: `BearerF ${this.lawFirmUserOnBoardingFormService.bearer}`
        }
      });
    }
    return next.handle(request);
  }
}
